import { FC } from "react";
import Icon from ".";
import { IconElementProps, createIconVariantMap } from "./Icon.types";

export const Filled12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M6 0.5C2.96243 0.5 0.5 2.96243 0.5 6C0.5 9.03757 2.96243 11.5 6 11.5C9.03757 11.5 11.5 9.03757 11.5 6C11.5 2.96243 9.03757 0.5 6 0.5ZM6 3.5C6.27614 3.5 6.5 3.72386 6.5 4V5.5H8C8.27614 5.5 8.5 5.72386 8.5 6C8.5 6.27614 8.27614 6.5 8 6.5H6.5V8C6.5 8.27614 6.27614 8.5 6 8.5C5.72386 8.5 5.5 8.27614 5.5 8V6.5H4C3.72386 6.5 3.5 6.27614 3.5 6C3.5 5.72386 3.72386 5.5 4 5.5H5.5V4C5.5 3.72386 5.72386 3.5 6 3.5Z" fill="currentColor" />
    </svg>
  );
};

export const Filled16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M8.00008 0.666992C3.94999 0.666992 0.666748 3.95024 0.666748 8.00033C0.666748 12.0504 3.94999 15.3337 8.00008 15.3337C12.0502 15.3337 15.3334 12.0504 15.3334 8.00033C15.3334 3.95024 12.0502 0.666992 8.00008 0.666992ZM8.00008 4.66699C8.36827 4.66699 8.66675 4.96547 8.66675 5.33366V7.33366H10.6667C11.0349 7.33366 11.3334 7.63214 11.3334 8.00033C11.3334 8.36852 11.0349 8.66699 10.6667 8.66699H8.66675V10.667C8.66675 11.0352 8.36827 11.3337 8.00008 11.3337C7.63189 11.3337 7.33342 11.0352 7.33342 10.667V8.66699H5.33342C4.96523 8.66699 4.66675 8.36852 4.66675 8.00033C4.66675 7.63214 4.96523 7.33366 5.33342 7.33366H7.33342V5.33366C7.33342 4.96547 7.63189 4.66699 8.00008 4.66699Z" fill="currentColor" />
    </svg>
  );
};

export const Filled20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M9.99992 0.833008C4.93731 0.833008 0.833252 4.93706 0.833252 9.99967C0.833252 15.0623 4.93731 19.1663 9.99992 19.1663C15.0625 19.1663 19.1666 15.0623 19.1666 9.99967C19.1666 4.93706 15.0625 0.833008 9.99992 0.833008ZM9.99992 5.83301C10.4602 5.83301 10.8333 6.2061 10.8333 6.66634V9.16634H13.3333C13.7935 9.16634 14.1666 9.53944 14.1666 9.99967C14.1666 10.4599 13.7935 10.833 13.3333 10.833H10.8333V13.333C10.8333 13.7932 10.4602 14.1663 9.99992 14.1663C9.53968 14.1663 9.16659 13.7932 9.16659 13.333V10.833H6.66659C6.20635 10.833 5.83325 10.4599 5.83325 9.99967C5.83325 9.53944 6.20635 9.16634 6.66659 9.16634H9.16659V6.66634C9.16659 6.2061 9.53968 5.83301 9.99992 5.83301Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6165_14493)">
        <path d="M10.5 6C10.5 3.51472 8.48528 1.5 6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C8.48528 10.5 10.5 8.48528 10.5 6ZM5.5 8V6.5H4C3.72386 6.5 3.5 6.27614 3.5 6C3.5 5.72386 3.72386 5.5 4 5.5H5.5V4C5.5 3.72386 5.72386 3.5 6 3.5C6.27614 3.5 6.5 3.72386 6.5 4V5.5H8C8.27614 5.5 8.5 5.72386 8.5 6C8.5 6.27614 8.27614 6.5 8 6.5H6.5V8C6.5 8.27614 6.27614 8.5 6 8.5C5.72386 8.5 5.5 8.27614 5.5 8ZM11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_6165_14493">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Outlined16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6165_14491)">
        <path d="M14.0001 8.00033C14.0001 4.68662 11.3138 2.00033 8.00008 2.00033C4.68637 2.00033 2.00008 4.68662 2.00008 8.00033C2.00008 11.314 4.68637 14.0003 8.00008 14.0003C11.3138 14.0003 14.0001 11.314 14.0001 8.00033ZM7.33342 10.667V8.66699H5.33342C4.96523 8.66699 4.66675 8.36852 4.66675 8.00033C4.66675 7.63214 4.96523 7.33366 5.33342 7.33366H7.33342V5.33366C7.33342 4.96547 7.63189 4.66699 8.00008 4.66699C8.36827 4.66699 8.66675 4.96547 8.66675 5.33366V7.33366H10.6667C11.0349 7.33366 11.3334 7.63214 11.3334 8.00033C11.3334 8.36852 11.0349 8.66699 10.6667 8.66699H8.66675V10.667C8.66675 11.0352 8.36827 11.3337 8.00008 11.3337C7.63189 11.3337 7.33342 11.0352 7.33342 10.667ZM15.3334 8.00033C15.3334 12.0504 12.0502 15.3337 8.00008 15.3337C3.94999 15.3337 0.666748 12.0504 0.666748 8.00033C0.666748 3.95024 3.94999 0.666992 8.00008 0.666992C12.0502 0.666992 15.3334 3.95024 15.3334 8.00033Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_6165_14491">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Outlined20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6165_14489)">
        <path d="M17.4999 9.99967C17.4999 5.85754 14.1421 2.49967 9.99992 2.49967C5.85778 2.49967 2.49992 5.85754 2.49992 9.99967C2.49992 14.1418 5.85778 17.4997 9.99992 17.4997C14.1421 17.4997 17.4999 14.1418 17.4999 9.99967ZM9.16659 13.333V10.833H6.66659C6.20635 10.833 5.83325 10.4599 5.83325 9.99967C5.83325 9.53944 6.20635 9.16634 6.66659 9.16634H9.16659V6.66634C9.16659 6.2061 9.53968 5.83301 9.99992 5.83301C10.4602 5.83301 10.8333 6.2061 10.8333 6.66634V9.16634H13.3333C13.7935 9.16634 14.1666 9.53944 14.1666 9.99967C14.1666 10.4599 13.7935 10.833 13.3333 10.833H10.8333V13.333C10.8333 13.7932 10.4602 14.1663 9.99992 14.1663C9.53968 14.1663 9.16659 13.7932 9.16659 13.333ZM19.1666 9.99967C19.1666 15.0623 15.0625 19.1663 9.99992 19.1663C4.93731 19.1663 0.833252 15.0623 0.833252 9.99967C0.833252 4.93706 4.93731 0.833008 9.99992 0.833008C15.0625 0.833008 19.1666 4.93706 19.1666 9.99967Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_6165_14489">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const variants = createIconVariantMap({
  filled: {
    12: Filled12,
    16: Filled16,
    20: Filled20,
  },
  outlined: {
    12: Outlined12,
    16: Outlined16,
    20: Outlined20,
  },
});

export const IconPlusCircle: FC<IconElementProps & { className?: string }> = (props) => (
  <Icon name={"plus-circle"} {...props} />
);
